import { isNonEmptyString } from '@/utils/checks'

export const UTM_PARAMS = [
  'utm_source=rehabpath',
  'utm_medium=referral',
  'utm_campaign=luxuryrehab'
]

const appendUtmSourceAndMediumToUrl = (url: string): string => {
  if (!isNonEmptyString(url)) {
    return ''
  }

  const urlAlreadyHasParams = url.includes('?')
  const urlAlreadyHasSource = url.includes('utm_source')

  if (urlAlreadyHasSource) {
    return url
  }

  if (urlAlreadyHasParams) {
    return UTM_PARAMS.reduce((acc, param) => {
      if (acc.includes(param)) {
        return acc
      }

      return `${acc}&${param}`
    }, url)
  }

  return `${url}?${UTM_PARAMS.join('&')}`
}

export default appendUtmSourceAndMediumToUrl
